import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import { setShowImportPopup, setUserPin, setUri } from '../actions/localStates'

class ImportTokenPopup extends Component {

  constructor(props) {
      super(props);
      this.state = {
          pin: "",
          uri: ""
      }

      this.handlePinInput = this.handlePinInput.bind(this);
      this.handleUriInput = this.handleUriInput.bind(this);

      this.setPin = this.setPin.bind(this);
      this.closeImportTokenPopup = this.closeImportTokenPopup.bind(this);

      this.handlePinKeyUp = this.handlePinKeyUp.bind(this, 'pinInput');
  }

  componentDidMount() {
      var element = document.getElementById("uri");
      element.focus();
      document.addEventListener('keyup', this.handlePinKeyUp);
  }

  componentWillUnmount() {
      document.removeEventListener('keyup', this.handlePinKeyUp);
  }

  handlePinKeyUp(refName, e) {
      if (e.keyCode === 13 && refName === "pinInput") {
          document.getElementById("submitPin").click();
          document.activeElement.blur();
      }
  }

  handlePinInput (e) {
    // console.log(e.target.value)
    this.setState({pin: e.target.value})
  }

  handleUriInput (e) {
    // console.log(e.target.value)
    this.setState({uri: e.target.value})
  }

  setPin () {
    this.props.actions.setUserPin(this.state.pin);
    this.props.actions.setUri(this.state.uri);

    this.props.closeImportPopup(this.state.pin, this.state.uri);
  }

  closeImportTokenPopup () {
    this.props.actions.setShowImportPopup(false);
  }

  hoverPin() {
        this.setState({showPin: true})
  }

  outPin() {
      this.setState({showPin: false})
  }

  render() {
    let isEnabled = this.state.pin.length >= 8 && this.state.uri.length > 0
    ? true
    : false

      return (
          <div className='popup'>
              <div className={"popup_inner_user_token_pin"}>
                  <div className="col-12" style={{marginTop: "30px"}}>
                      <h4 style={{paddingLeft: "15px", color: "#b5b1af"}}>{i18next.t("importTokenLabel")}</h4>
                      <div>
                          <label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af"}}>{i18next.t("tokenUri")}</label>
                          <div className="col-12 input-group">
                              <input id="uri" className="form-control" value={this.state.uri} type="input" onChange={this.handleUriInput} />
                          </div>

                          <label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af"}}>{i18next.t("pinInput")}</label>
                          <div className="col-12 input-group">
                              <input id="pin" className="form-control" value={this.state.pin} type={this.state.showPin ? "input" : "password"} onChange={this.handlePinInput} />
                              <div className="input-group-append">
                                  <div className="input-group-text" onMouseOver={this.hoverPin.bind(this)} onMouseOut={this.outPin.bind(this)}><i className="fa fa-eye"></i></div>
                              </div>
                          </div>

                      </div>
                      <div style={{float: "right", marginRight: "15px", paddingTop: "10px"}}>
                          <button className="btn btn-info" id="submitPin" style={{marginLeft: "5px", marginBottom: "30px"}} disabled={!isEnabled} onClick={this.setPin}>{i18next.t("import")}</button>
                          <button className="btn btn-outline-info" style={{marginLeft: "5px", marginBottom: "30px"}} onClick={this.closeImportTokenPopup}>{i18next.t("cancelLabel")}</button>
                      </div>
                  </div>
              </div>
          </div>
      );
    }
}

function mapStateToProps(state) {
    return {
        base: state.base,
        selectedClient: state.clientReducer,
        login: state.loginReducer,
        userReducer: state.userReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
      setShowImportPopup, setUserPin, setUri
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportTokenPopup);